import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, delay, repeat, switchMap } from 'rxjs/operators';
import { ScannerApiService } from '../scanner/scanner-api.service';
import { HttpEvent } from '@angular/common/http';
import { ApiTopService } from '../api/api-top.service';
import { StateInterface } from '../../interfaces/biozoom-api/app-configuration';
import { PreRequestResult } from 'src/app/interfaces/biozoom-api/pre-request-result';
import { AoxMeasurementResult } from 'src/app/interfaces/biozoom-api/aox-measurement-result';

@Injectable({
  providedIn: 'root'
})

/**
 * the purpose of this service is to wrap multiple modular calls
 * into a singular Observable that describes a single step for the end-user
 * it also ensures that the results are easily parsable and allows for
 * checks whether the step has been completed
 */
export class ScanNutritionService {

  constructor(
    private apiTopService: ApiTopService,
    private scannerApiService: ScannerApiService,
  ) { }


  startMeasurement = (state: StateInterface, measurementType: string): Observable<HttpEvent<any>> => {
    return this.scannerApiService.getMeasurement(state, measurementType).pipe(
      switchMap((el) => {
        return of(el);
      }),
    );
  }


  calculateMeasurementResult = (
    demoMode: boolean,
    language: string,
    serial: string,
    data: string,
    additionalData?: any,
    preRequestTimeoutMs?: number,
  ) => {
    return of({}).pipe(
      switchMap(() => {
        console.log('Calculate using new server structure.');
        return this.apiTopService.executeMeasurementAoxVWS(
          demoMode,
          serial,
          data,
          language,
          additionalData,
          preRequestTimeoutMs,
        );
      }),
      catchError((err) => {
        if (err === 'license') {
          return of(false);
        }
        console.log(err);
        console.warn('Fallback to old server structure.');
        return this.apiTopService.executeMeasurementAox(
          demoMode,
          serial,
          data,
          language,
          additionalData
        );
      }
      )
    );
  }

  requestAoxUploadServer = (
    demoMode: boolean,
    serial: string,
    preRequestTimeoutMs?: number,
  ): Observable<PreRequestResult> => {
    return this.apiTopService.requestMeasurementAoxVWS(demoMode, serial, preRequestTimeoutMs);
  }

  requestAoxUploadServerOnServer = (
    demoMode: boolean,
    serial: string,
    vwsBaseUrl: string,
    preRequestTimeoutMs?: number,
  ): Observable<PreRequestResult> => {
    return this.apiTopService.requestMeasurementAoxVWSOnServer(
      demoMode, serial, vwsBaseUrl, preRequestTimeoutMs
    );
  }

  getAoxUploadServers = (): string[] => this.apiTopService.getAoxVwsServers();

  uploadAoxToSelectedServer = (
    demoMode: boolean,
    serial: string,
    data: string,
    waitingTimeMs: number,
    recommendedServer: string,
    language: string,
    additionalData?: any,
  ): Observable<HttpEvent<AoxMeasurementResult>> => {
    return this.apiTopService.executeMeasurementAoxVWSOnServer(
      demoMode, serial, data, waitingTimeMs, recommendedServer, language, additionalData
    );
  }

  uploadAoxToDirectServer = (
    demoMode: boolean,
    serial: string,
    data: string,
    language: string,
    additionalData?: any,
  ): Observable<HttpEvent<AoxMeasurementResult>> => {
    return this.apiTopService.executeMeasurementAoxDirectSingle(demoMode, serial, data, language, additionalData);
  }


  mockService = () => {
    return of({}).pipe(
      delay(2000),
      repeat(),
      switchMap(() => {
        console.log('Repeat');
        return of(1);
      })
    );
  }
}
